import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KbArticlesCreateComponent } from './kb-articles/kb-articles-create/kb-articles-create.component';
import { KbArtilesSingleComponent } from './kb-articles/kb-articles-display/kb-articles-display.component';
import { HomeComponent } from './home/home.component';
import { PortalComponent } from './dashboard/portal/portal.component';
import { GridComponent } from './dashboard/grid/grid.component';
import { TextEditorComponent } from './kb-articles/text-editor/text-editor.component';
import { AuthGuard } from './shared/routeguards/auth.guard';
import { KbArticlesFolderRestoreComponent } from './kb-articles/kb-articles-folder-restore/kb-articles-folder-restore.component';

const routes: Routes = [
  {path:'',component:HomeComponent},
  {path:'home',component:HomeComponent},
  {path:'editor',component:TextEditorComponent},
  {path:'portal',component:PortalComponent,canActivate:[AuthGuard]},
  {path:'grid/:status',component:GridComponent,canActivate:[AuthGuard]},
  {path:':navUrl/:navUrl/article/create',component:KbArticlesCreateComponent,canActivate:[AuthGuard]},
  {path:':navUrl/:navUrl/article/:id',component:KbArtilesSingleComponent},
  {path:':navUrl/:navUrl/article/edit/:articleId',component:KbArticlesCreateComponent,canActivate:[AuthGuard]},
  {path:'restoreFolder',component:KbArticlesFolderRestoreComponent,canActivate:[AuthGuard]},
];




@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(){}

}

